import { Box } from '@chakra-ui/react';
import type React from 'react';
import FaceliftDataLoader from '@/components/Atoms/FaceliftDataLoader';
import FaceliftText from '@/components/Atoms/FaceliftText';
import { useGetReturnOrderById } from '@/hooks/service-hooks/returns';
import { formatDate } from '@/utils';
import OrderReturnDetailsView from './OrderReturnDetailsView';

interface OrderReturnDetailsProps {
	returnOrderId: string;
}

const OrderReturnDetails: React.FC<OrderReturnDetailsProps> = ({ returnOrderId }) => {
	const { data, isLoading } = useGetReturnOrderById(returnOrderId);

	const returnOrder = data?.data;

	if (isLoading) {
		return (
			<FaceliftDataLoader
				title="Loading return order details..."
				description="Please wait while we fetch the latest return order information."
			/>
		);
	}

	if (!returnOrder) {
		return (
			<Box p={4}>
				<FaceliftText>Return order not found</FaceliftText>
			</Box>
		);
	}

	// Transform data to match the shared component's interface
	// Map through inventories array to get all products
	const products = returnOrder.inventories?.map((inventory) => ({
		ta_tissueid: inventory.ta_tissueid,
		ta_expirationdate: formatDate(returnOrder.ta_expirationdate),
		ta_datereturnedtransferred: formatDate(returnOrder.ta_datereturnedtransferred),
		ta_newshippingdaterequested: formatDate(returnOrder.ta_newshippingdaterequested),
	})) || [];

	const viewData = {
		clinicName: returnOrder.clinic?.name || '',
		ta_contact: returnOrder.ta_contact,
		ta_phone: returnOrder.ta_phone,
		ta_streetaddress: returnOrder.ta_streetaddress,
		ta_city: returnOrder.ta_city,
		ta_statezip: returnOrder.ta_statezip,
		products: products,
		ta_hastheproductbeeninyourpossessionupon: returnOrder.ta_hastheproductbeeninyourpossessionupon,
		ta_hastheproductbeenstoredaccordingtothemanu: returnOrder.ta_hastheproductbeenstoredaccordingtothemanu,
		ta_hastheproductbeensecurelystoredbyauthoriz: returnOrder.ta_hastheproductbeensecurelystoredbyauthoriz,
		ta_hasanyproductbeenusedoropen: returnOrder.ta_hasanyproductbeenusedoropen,
		ta_istheproductintheoriginalunmarkedandundam: returnOrder.ta_istheproductintheoriginalunmarkedandundam,
		ta_commentsclarifications: returnOrder.ta_commentsclarifications,
		orderRequest: returnOrder.orderRequest?.ta_orderrequestid && returnOrder.orderRequest?.ta_name
			? {
					ta_orderrequestid: returnOrder.orderRequest.ta_orderrequestid,
					ta_name: returnOrder.orderRequest.ta_name,
					navigateTo: `/requests?orderId=${returnOrder.orderRequest.ta_orderrequestid}`,
				}
			: undefined,
	};

	return <OrderReturnDetailsView data={viewData} />;
};

export default OrderReturnDetails;

